/**
 * Business shell L1 identity — logoUrl or tenant name (no Site cssVars :root inject)
 */

import React from 'react';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useBusinessBrand } from '../../providers/BusinessBrandContext';
import { useTenant } from '../../contexts/TenantContext';

export interface BusinessShellBrandProps {
  className?: string;
  /** Top bar home navigation */
  interactive?: boolean;
}

function resolveShellLabel(
  brandDisplayName: string | undefined,
  tenantDisplayName: string | undefined,
  tenantName: string | undefined
): string {
  return (
    brandDisplayName?.trim() || tenantDisplayName?.trim() || tenantName?.trim() || 'Inflomatrix'
  );
}

export const BusinessShellBrand: React.FC<BusinessShellBrandProps> = ({
  className,
  interactive = false,
}) => {
  const navigate = useNavigate();
  const { brand } = useBusinessBrand();
  const { currentTenant } = useTenant();

  const label = resolveShellLabel(
    brand?.tenantDisplayName,
    currentTenant?.displayName,
    currentTenant?.name
  );
  const logoUrl = brand?.logoUrl?.trim();
  const platformFallbackLogo = '/brand/inflomatrix/logo/inflomatrix-symbol.svg';

  const content = logoUrl ? (
    <img src={logoUrl} alt={label} className="business-shell-brand__logo" />
  ) : label === 'Inflomatrix' ? (
    <img
      src={platformFallbackLogo}
      alt={label}
      className="business-shell-brand__logo"
      width={28}
      height={28}
    />
  ) : (
    <>
      {interactive && <HomeOutlined aria-hidden />}
      <span className={interactive ? undefined : 'im-text-gradient'}>{label}</span>
    </>
  );

  if (interactive) {
    return (
      <Button
        type="text"
        onClick={() => navigate('/')}
        {...(className !== undefined ? { className } : {})}
        aria-label={`${label} 홈으로 이동`}
        data-testid="business-shell-brand"
      >
        {content}
      </Button>
    );
  }

  return (
    <div className={className} data-testid="business-shell-brand">
      {content}
    </div>
  );
};

export default BusinessShellBrand;
